const organizations = {
  addMember: 'Ajouter un membre',
  cannotDeleteLastOrganization: 'Vous ne pouvez pas supprimer votre dernière organisation',
  createAnOrganization: 'Créer une organisation',
  members: 'Membres',
  myOrganization: 'Mon organisation',
  noMembersToDisplay: 'Aucun membre à afficher',
  noOrganizationsToDisplay: 'Aucune organisation à afficher',
  organizationDeleteFailed: 'L\'organisation n\'a pas pu être supprimée',
  organizations: 'Organisations',
};

export default organizations;
